import './viewTransporterMappingRoutes.css';
import React, { useState, useEffect, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import TrashIcon from '../../../images/TrashIcon.png';
import { MDBSwitch } from 'mdb-react-ui-kit';
import { lastFiveDigitsComparator, titleCase } from '../../../common/commonFunction';
import { getAllRoutes, viewAllMappedTransporter, DeleteDeactiveEditTransporterMapping } from './transportermappingApi';
import { PROD } from '../../../common/constants';
import { Card, CardContent, Container, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { NO_DATA_AVAILABLE } from '../../../common/constants';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';
import { checkMappingExists } from '../stakeHolderMapping/stakeholderMappingApi';

function ViewTransporterMappingRoutes() {
  const [message, setMessage] = useState("");
  const [details, setDetails] = useState({
    mappingRoute: ""
  });
  const [editTransDetails, setEditTransDetails] = useState({
    route: "",
    transporterUrn: "",
    sourceStakeholderUrn: "",
    targetStakeholderUrn: "",
    editid: "",
    sourceStakeholderName: "",
    targetStakeholderName: "",
    deleteid: "",
    deactiveid: "",
    finaldeactivestatus: ""
  });
  const [chooseTransRoute, setChooseTransRoute] = useState([]);
  const [saveEditDetails, setsaveEditDetails] = useState([]);
  const [mappingResponseDetails, setMappingResponseDetails] = useState([])
  const [viewAllTransporterDetails, setViewAllTransporterDetails] = useState()
  let [showData, setshowData] = useState(false);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [checkData, setCheckData] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [searchNameInput, setSearchNameInput] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const routelog = useRef(true);
  const [deactivestatus, setdeactivestatus] = useState()
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  useEffect(() => {
    if (routelog.current) {
      routelog.current = false;
      getAllRoutes(setChooseTransRoute);
    }
  }, [routelog]);
  const handleChange = (e) => {
    e.preventDefault();
    setDetails({ ...details, [e.target.name]: e.target.value });
    if (e.target.name === "mappingRoute") {
      viewAllMappedTransporter(e.target.value, setViewAllTransporterDetails, setCheckData)
      checkData ? setshowData(true) : setshowData(false)
    }
  }
  const onDeleteMappedTransporter = (e, item) => {
    e.preventDefault();
    setEditTransDetails({ ...editTransDetails, route: details?.mappingRoute, deleteid: item?.id, transporterUrn: item?.transporterDetails.urn, sourceStakeholderUrn: item?.stakeholderDetailsFrom.urn, targetStakeholderUrn: item?.stakeholderDetailsTo.urn })
    const data = {
      "sourceStakeholderUrn": item?.stakeholderDetailsFrom.urn,
      "targetStakeholderUrn": item?.stakeholderDetailsTo.urn,
      "transporterUrn": item?.transporterDetails.urn,
      "transporterName": "",
      "route": details.mappingRoute,
      "operation": "Delete",
    }
    checkMappingExists(data, handleConfirmLogModalOpen, setMessage);
    // handleConfirmLogModalOpen();
  };

  const onDeactiveMapped = (e, item) => {
    e.preventDefault();
    if (item.isActive === 'N') {
      setdeactivestatus("N")
    }
    else {
      setdeactivestatus("Y")
    }
    setEditTransDetails({ ...editTransDetails, route: details?.mappingRoute, deactiveid: item?.id, transporterUrn: item?.transporterDetails.urn, sourceStakeholderUrn: item?.stakeholderDetailsFrom.urn, targetStakeholderUrn: item?.stakeholderDetailsTo.urn })
    const data = {
      "sourceStakeholderUrn": editTransDetails.sourceStakeholderUrn,
      "targetStakeholderUrn": editTransDetails.targetStakeholderUrn,
      "transporterUrn": editTransDetails.transporterUrn,
      "transporterName": "",
      "route": details.mappingRoute,
      "operation": (item.isActive === "Y") ? "Deactivate" : "Activate",
    }
    checkMappingExists(data, handleConfirmLogModalOpen, setMessage);
    // handleConfirmLogModalOpen();
  };
  const onConfirmCallBack = async () => {
 if (isApiCalled) return;   
 setIsApiCalled(true);
 try {
   if (editTransDetails.deactiveid || editTransDetails.deleteid) {
     await DeleteDeactiveEditTransporterMapping(
       editTransDetails,
       deactivestatus,
       setMappingResponseDetails,
       details
     );
   }
 } catch (err) {
   console.error("API FAILED: ", err);
 } finally {
   setIsApiCalled(false);      
   handleConfirmLogModalClose(); 
 }
};

  
  function onCancelBack() {
    handleConfirmLogModalClose();
    setEditTransDetails('');
  }
  useEffect(() => {
    if (mappingResponseDetails) {
      if (mappingResponseDetails.statusCde === '100') {
        if (mappingResponseDetails?.status === "SUCCESS") {
          toast.success(mappingResponseDetails?.description)
        }
        else toast.error(mappingResponseDetails?.description)
      }
      setEditTransDetails({ ...editTransDetails, deactiveid: "", deleteid: "", editTransDetails: "", targetStakeholderUrn: "", transporterUrn: "" });
      setdeactivestatus("")
      setSearchInput("")
      setSearchNameInput("")
      viewAllMappedTransporter(editTransDetails.route, setViewAllTransporterDetails, setCheckData)
    }
  }, [mappingResponseDetails]);

  const viewMappingCol = [
    {
      field: 'transporterurn', headerName: 'Transporter URN', width: 150, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
      valueGetter: (params) => {
        return params?.row?.transporterDetails?.urn
      },
      renderCell: (params) => (
        <Typography>{params?.row?.transporterDetails?.urn}</Typography>
      )
    },
    {
      field: 'transportername', headerName: 'Transporter Name', width: 150,
      valueGetter: (params) => {
        return params?.row?.transporterDetails?.name
      },
      renderCell: (params) => (
        <Typography>{params?.row?.transporterDetails?.name && titleCase(params?.row?.transporterDetails?.name)}</Typography>
      )
    },
    {
      field: 'stakeholderurn', headerName: 'Source Stakeholder URN', width: 200, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsFrom?.urn
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsFrom?.urn}</Typography>
      )
    },
    {
      field: 'stakeholdername', headerName: 'Source Stakeholder Name', width: 200,
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsFrom?.name
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsFrom?.name && titleCase(params?.row?.stakeholderDetailsFrom?.name)}</Typography>
      )
    },
    {
      field: 'stakeholderaddress', headerName: 'Source Stakeholder Address', width: 200,
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsFrom?.address
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsFrom?.address && titleCase(params?.row?.stakeholderDetailsFrom?.address)}</Typography>
      )
    },
    {
      field: 'stakeholderdistrict', headerName: 'Source Stakeholder District', width: 200,
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsFrom?.district
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsFrom?.district && titleCase(params?.row?.stakeholderDetailsFrom?.district)}</Typography>
      )
    },
    {
      field: 'targetstakeholderurn', headerName: 'Targeted Stakeholder URN', width: 200, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsTo?.urn
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsTo?.urn}</Typography>
      )
    },
    {
      field: 'targetstakeholdername', headerName: 'Targeted Stakeholder Name', width: 200,
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsTo?.name
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsTo?.name && titleCase(params?.row?.stakeholderDetailsTo?.name)}</Typography>
      )
    },
    {
      field: 'targetstakeholderaddress', headerName: 'Targeted Stakeholder Address', width: 200,
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsTo?.address
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsTo?.address && titleCase(params?.row?.stakeholderDetailsTo?.address)}</Typography>
      )
    },
    {
      field: 'targetstakeholderdistrict', headerName: 'Targeted Stakeholder District', width: 200,
      valueGetter: (params) => {
        return params?.row?.stakeholderDetailsTo?.district
      },
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderDetailsTo?.district && titleCase(params?.row?.stakeholderDetailsTo?.district)}</Typography>
      )
    },
    {
      field: 'action', headerName: 'Activate/Deactivate', width: 150,
      valueGetter: (params) => {
        return params?.row?.isActive === 'N' ? "Deactivated" : "Activated"
      },
      renderCell: (params) => (
        <MDBSwitch checked={params?.row?.isActive === 'N' ? false : true} style={{ cursor: "pointer" }} onClick={(e) => onDeactiveMapped(e, params?.row)} id='flexSwitchCheckChecked' />
      )
    },
    {
      field: 'deleteaction', headerName: 'Delete', width: 70,
      valueGetter: (params) => {
        return "Delete"
      },
      renderCell: (params) => (
        <img src={TrashIcon} style={{ cursor: "pointer" }} onClick={(e) => onDeleteMappedTransporter(e, params?.row)} alt="TrashIcon" />
      )
    },
  ]
  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className='pageNumberingResc'>RES04</p>}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h5" gutterBottom>
            View Transporter Mapping Routes
          </Typography>
        </Stack>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={4}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                  <InputLabel id="mappingroute-label">Mapping Route</InputLabel>
                  <Select
                    label="Mapping Route"
                    name="mappingRoute" onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Select Stakeholder</em></MenuItem>
                    {
                      chooseTransRoute?.map((item) =>
                        <MenuItem value={item}>{item}</MenuItem>)
                    }
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {viewAllTransporterDetails ?
              <Grid item xs={12} lg={12}>
                <Box sx={{ height: 350, width: '100%', mt: 2 }}>
                  <DataGrid
                    rows={viewAllTransporterDetails?.data}
                    columns={viewMappingCol}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    getRowId={(row) => row?.id}
                    components={{
                      Toolbar: CustomDataGridToolbar,
                    }}
                    componentsProps={{ toolbar: { rows: viewAllTransporterDetails?.data, columns: viewMappingCol, fileName: "ViewTransporterMappingList.xlsx", } }}
                  />
                </Box>
              </Grid>
              : showData ?
                <Typography display='flex' alignItems="center" justifyContent="center" sx={{ fontWeight: "bold" }}>{NO_DATA_AVAILABLE}</Typography>
                : null
            }
          </CardContent>
        </Card>
      </Container>
      <ConfirmationPopover onOpen={logConfirmModalOpen} specialMessage={message} onConfirm={onConfirmCallBack} onClose={onCancelBack} action={(deactivestatus === "Y") ? "Deactive" : editTransDetails.deleteid ? "Delete" : "Active"} isResourceSubmit={true} />
    </>
  );
}

export default ViewTransporterMappingRoutes;
